import {
	SofaConfigurationState,
	SET_SOFA_CONFIGURATION,
	SET_SELECTED_CONFIGURATION,
	SET_MISSING_CONFIGURATION,
	SET_PERSISTED_CONFIGURATION,
	SET_SHOPPING_ITEMS,
	SET_PREDEFINED_CONFIGURATION_ID,
	SET_GALLERY_PREDEFINED_CONFIGURATION_ID,
	SET_UPDATE_PREDEFINED_CONFIGURATION,
	SET_MISSING_DEEPLINK,
} from './types';
import { SHOW_SCREENSAVER } from '../screensaver/types';
import { Actions } from '..';
import { SET_SCENE_DATA } from '../scene/types';
import { SET_ADDITIONAL_COVER_ITEMS } from '../cover/types';

const initialState: SofaConfigurationState = {
	sofaConfiguration: {},
	selectedConfiguration: {
		configuration: {},
	},
	missingConfiguration: null,
	persistedConfiguration: null,
	shoppingItems: [],
	predefinedConfigurationId: null,
	updatePredefinedConfiguration: false,
	missingDeeplink: null,
};

export function sofaConfigurationReducer(
	state: SofaConfigurationState = initialState,
	action: Actions
): SofaConfigurationState {
	switch (action.type) {
		case SET_SCENE_DATA: {
			return {
				...state,
				sofaConfiguration: action.sofaConfiguration,
			};
		}
		case SET_SOFA_CONFIGURATION:
			return { ...state, sofaConfiguration: action.value };
		case SET_MISSING_CONFIGURATION:
			return { ...state, missingConfiguration: action.value };
		case SET_SELECTED_CONFIGURATION:
			return {
				...state,
				updatePredefinedConfiguration: true,
				selectedConfiguration: action.value,
			};
		case SET_PERSISTED_CONFIGURATION: {
			return { ...state, persistedConfiguration: action.value };
		}
		case SET_SHOPPING_ITEMS:
			return { ...state, shoppingItems: action.value };
		case SHOW_SCREENSAVER: {
			if (!action.value) {
				return { ...state, updatePredefinedConfiguration: true };
			}
			return state;
		}
		case SET_PREDEFINED_CONFIGURATION_ID: {
			return { ...state, predefinedConfigurationId: action.value };
		}
		case SET_GALLERY_PREDEFINED_CONFIGURATION_ID: {
			return { ...state, galleryPredefinedConfigurationId: action.value };
		}
		case SET_UPDATE_PREDEFINED_CONFIGURATION: {
			return { ...state, updatePredefinedConfiguration: action.value };
		}
		case SET_MISSING_DEEPLINK: {
			return { ...state, missingDeeplink: action.value };
		}
		case SET_ADDITIONAL_COVER_ITEMS: {
			const previousSofaConfiguration = state.sofaConfiguration;
			previousSofaConfiguration.additionalCoverItems = action.value;

			return {
				...state,
				sofaConfiguration: previousSofaConfiguration,
			};
		}
		default:
			return state;
	}
}
